import React from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { StrategyRefactored } from '../components/Strategy';

const Strategies = ({ initialTab }) => {
  return (
    <DashboardLayout>
      <StrategyRefactored initialTab={initialTab} />
    </DashboardLayout>
  );
};

export default Strategies;
